<template>
  <el-table-column
    prop="date"
    sortable="custom"
    label="Dátum"
    min-width="120"
  >
    <template slot-scope="scope">
      {{ scope.row.date | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
